import {
    FORM_ENTRIES_LOADING,
    FORM_ENTRIES_LOADING_STOP,
    FORM_ENTRIES_SET_MIGRATION_PANES,
    getFormEntry,
    PrimaryButton,
    updateFormEntryFrontend,
} from "@rpforms/shared";
import { DangerButton } from "@rpforms/shared/build/components/Button";
import { Loader } from "@rpforms/shared/build/components/universal/Loader";
import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "../../reducers";

export const ModalMigration = ({ editor, next }) => {
    const dispatch = useDispatch();
    const isLoading = useSelector<RootState>((state) => state.formEntries.isLoading);

    const save = (i, mode) => {
        const formEntries = { ...editor.config.preload };
        const formEntryId = formEntries[i].form_entry.id || formEntries[i].source_form_entry.id;
        dispatch({
            type: FORM_ENTRIES_LOADING,
            payload: [],
        });
        dispatch(
            updateFormEntryFrontend(
                formEntryId,
                formEntries[i].form_entry.form_data,
                {
                    name: formEntries[i].form_entry.name,
                    form_revision_id: formEntries[i].form_entry.form_revision_id,
                    form_id: formEntries[i].form_entry.form_id,
                    entity_id: formEntries[i].form_entry.entity_id,
                    buyer_order_reference_number: formEntries[i].form_entry.buyer_order_reference_number,
                    zugferd_bt_fields: formEntries[i].form_entry.zugferd_bt_fields || {},
                },
                mode,
                (fromEntryData) => {
                    dispatch({
                        type: FORM_ENTRIES_SET_MIGRATION_PANES,
                        payload: [],
                    });
                    dispatch({
                        type: FORM_ENTRIES_LOADING_STOP,
                        payload: [],
                    });
                    dispatch(getFormEntry(formEntryId));
                    toast.success("Gespeichert");
                    window.history.back();
                    // dispatch(push("/entries"));
                    next();
                },
                (err) => {
                    alert(
                        "Das hat leider nicht geklappt, bitte überprüfen Sie das Protokoll und versuchen Sie es erneut. Fehler: " +
                            err.message
                    );
                    dispatch({
                        type: FORM_ENTRIES_LOADING_STOP,
                        payload: [],
                    });
                }
            )
        );
    };

    const onSubmitMigration = async (data) => {
        save(1, "new");
    };

    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>Speichern</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        Sie können hiermit das Formular als neuen Eintrag speichern (nur die rechte Seite).
                        {isLoading && <Loader />}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <PrimaryButton
                    style={isLoading ? { background: "gray" } : {}}
                    type={"submit"}
                    onClick={onSubmitMigration}
                    disabled={!!isLoading}
                >
                    als neuer Eintrag
                </PrimaryButton>
            </Modal.Footer>
        </>
    );
};
